import React, { useEffect, useState } from 'react';
import './Cursor.css';

const Cursor = () => {
  const [pointerPos, setPointerPos] = useState({ x: 0, y: 0 });
  const [shadowPos, setShadowPos] = useState({ x: 0, y: 0 });
  const [trailPos1, setTrailPos1] = useState({ x: 0, y: 0 });
  const [trailPos2, setTrailPos2] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);
  const [prevPos, setPrevPos] = useState({ x: 0, y: 0 });
  const [speed, setSpeed] = useState(0);
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    // Check if it's a touch device
    const checkTouchDevice = () => {
      return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
    };
    setIsTouchDevice(checkTouchDevice());
  }, []);

  useEffect(() => {
    if (isTouchDevice) return;

    const update = (e) => {
      const currentPos = { x: e.clientX, y: e.clientY };
      setPointerPos(currentPos);
      
      // Calculate speed
      const dx = currentPos.x - prevPos.x;
      const dy = currentPos.y - prevPos.y;
      const distance = Math.sqrt(dx * dx + dy * dy);
      setSpeed(distance);
      setPrevPos(currentPos);
      
      // Check if hovering over interactive elements
      const element = document.elementFromPoint(e.clientX, e.clientY);
      if (element) {
        const isInteractive = element.tagName === 'BUTTON' || 
                             element.tagName === 'A' || 
                             element.closest('button, a, [role="button"], .cursor-hover');
        setIsHovering(isInteractive);
      }
    };
    document.addEventListener('mousemove', update);
    return () => document.removeEventListener('mousemove', update);
  }, [prevPos, isTouchDevice]);

  // smoothly move the shadow toward the pointer
  useEffect(() => {
    if (isTouchDevice) return;

    let frame;
    const lerp = (a, b, n) => (1 - n) * a + n * b;

    const animate = () => {
      setShadowPos((prev) => ({
        x: lerp(prev.x, pointerPos.x, 0.15),
        y: lerp(prev.y, pointerPos.y, 0.15),
      }));
      setTrailPos1((prev) => ({
        x: lerp(prev.x, pointerPos.x, 0.08),
        y: lerp(prev.y, pointerPos.y, 0.08),
      }));
      setTrailPos2((prev) => ({
        x: lerp(prev.x, pointerPos.x, 0.04),
        y: lerp(prev.y, pointerPos.y, 0.04),
      }));
      frame = requestAnimationFrame(animate);
    };

    animate();
    return () => cancelAnimationFrame(frame);
  }, [pointerPos, isTouchDevice]);

  // Don't render cursor on touch devices
  if (isTouchDevice) {
    return null;
  }

  return (
    <>
      <div
        className="cursor-trail trail-2"
        style={{
          left: `${trailPos2.x}px`,
          top: `${trailPos2.y}px`,
        }}
      />
      <div
        className="cursor-trail trail-1"
        style={{
          left: `${trailPos1.x}px`,
          top: `${trailPos1.y}px`,
        }}
      />
      <div
        className={`cursor-shadow ${isHovering ? 'hover' : ''} ${speed > 10 ? 'fast' : ''}`}
        style={{
          left: `${shadowPos.x}px`,
          top: `${shadowPos.y}px`,
        }}
      />
    </>
  );
};

export default Cursor;